import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const WelcomePage = lazy(
  () =>
    import('./WelcomePage.eager').then(mod => ({
      default: mod.WelcomePage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
